import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useTranslation } from 'react-i18next';
import AdminPageLayout from '../../layout/AdminPageLayout';
import Headline from '../../ui/Headline';
import Button from '../../ui/Button';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from '../../app.config.vars/routes';
import { generateIdRoutePath } from '../../helpers';
import RallyInfoCard from '../../ui/RalliyInfoCard';
import AdminStatisticRaw from '../../ui/AdminStatisticRow';
import ButtonsGroup from '../../ui/ButtonsGroup';
const AdminRallyResultsLayout = ({ rallyId, rallyTitle, themes, geographicArea, targetGroups, finishRate, time, playerCount, view, title, children, points, }) => {
    const { i18n } = useTranslation();
    const navigate = useNavigate();
    return (_jsx(AdminPageLayout, { logoutButton: true, children: _jsxs("div", { className: 'page-content-wrapper admin-rally-results-page', children: [view === 'single' && (_jsx("div", { className: 'sessions-list-nav-button', children: _jsx(ButtonsGroup, { children: _jsx(Button, { variant: 'outlined', label: 'Return to list', onClick: () => navigate(generateIdRoutePath(APP_ROUTES.adminRallySessions, rallyId)) }) }) })), _jsx(Headline, { title: title, type: 'h2', layout: 1 }), _jsx(RallyInfoCard, { title: rallyTitle, themes: themes.map((theme) => ({
                        uid: theme.id,
                        title: theme.title[i18n.language],
                    })), targetGroups: targetGroups.map((group) => ({
                        uid: group.id,
                        title: group.title[i18n.language],
                    })), additionalContent: _jsx(AdminStatisticRaw, { view: view, finishRate: finishRate, playerCount: playerCount, time: time, points: points }) }), children] }) }));
};
export default AdminRallyResultsLayout;
